<template>
  <ValidationObserver ref="inclusionsPage" id="inclusionsPage" name="inclusionsPage">
    <div v-if="loadingInclusions" class="text-center font-size-h2">
      <b-spinner variant="primary"></b-spinner>
    </div>

    <div v-if="!loadingInclusions && !inclusions">
      <div class="form-group">
        <h4 class="text-center">No data available.</h4>
      </div>
    </div>

    <div v-if="!loadingInclusions && inclusions && brand">

        <div class="form-group">
          <button class="btn btn-primary" @click.prevent="exportInclusions">
            <i class="fa fa-file-excel"></i>
            Download Inclusions
          </button>
        </div>

        <div class="form-group">
          Please use the <i class="fa fa-angle-double-down fa-sm text-dark"/> and <i class="fa fa-angle-double-up fa-sm text-dark"/> buttons below to expand/collapse each section.
        </div>

        <inclusions
            v-if="inclusions.generalBenefits.length > 0"
            expanded="false" :is-read-only="true" :show-order="false" :show-text-modified-column="false"
            title="General Benefits / Extensions" inclusionKey="generalBenefits"
            :selected-inclusions="inclusions.generalBenefits"
            :all-inclusions="inclusions.generalBenefits"
            :ignore-business-activities="isBrandFuse"
        />

        <inclusions
            v-if="inclusions.excesses.length > 0"
            expanded="false" :is-read-only="true"
            title="Excesses" inclusionKey="excesses" :show-order="false" :show-text-modified-column="false"
            :selected-inclusions="inclusions.excesses"
            :all-inclusions="inclusions.excesses"
            :ignore-business-activities="isBrandFuse"
        />

        <inclusions
            v-if="inclusions.policyConditions.length > 0"
            expanded="false" :is-read-only="true" :show-order="false" :show-text-modified-column="false"
            title="Policy Conditions" inclusionKey="policyConditions"
            :selected-inclusions="inclusions.policyConditions"
            :all-inclusions="inclusions.policyConditions"
            :ignore-business-activities="isBrandFuse"
        />

      </div>
  </ValidationObserver>
</template>

<style lang="scss">
</style>

<script>

import Inclusions from "@/view/pages/wizard/policy-details-view/components/Inclusions.vue";

export default {
  name: "InclusionsPage",

  components: {Inclusions},

  props: {
    inclusions: Object,
    brand: String,
    loadingInclusions: Boolean
  },

  data() {
    return {
    };
  },

  computed: {
    isBrandFuse: function () {
      return this.brand === 'Fuse' || this.brand === 'Fuse MSI';
    },
  },

  methods: {
    exportInclusions: function () {
      this.$emit('exportInclusions');
    }
  }
};
</script>
